// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.distribution-notes-link {
  margin-top: 1.8rem;
}
.distribution-notes-link,
.distribution-notes-link a {
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Navigations/RoyaltiesLink/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;;EAEE,aAAA;EACA,mBAAA;AACJ","sourcesContent":[".distribution-notes-link {\n  margin-top: 1.8rem;\n\n  &,\n  a {\n    display: flex;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
